import { render, staticRenderFns } from "./PendingPayoutAlert.vue?vue&type=template&id=4397811c&"
import script from "./PendingPayoutAlert.vue?vue&type=script&lang=js&"
export * from "./PendingPayoutAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports